// @flow

export type InvoiceDocument = {
  role: string,
  fileType: string,
  identifier: string,
  isAvailable: boolean
}

const buildInvoiceDocument = (): InvoiceDocument => {
  return {
    role: '',
    fileType: '',
    identifier: '',
    isAvailable: false
  }
}

export {
  buildInvoiceDocument
}



// WEBPACK FOOTER //
// ./src/types/invoice-document.js